export default __webpack_public_path__ + "static/media/ai-filled.c678b0bb.svg";